
import { AxiosError } from 'axios'
import { defineComponent } from 'vue'
import { baseFetch, download, FetchedData } from '@/services/api'
import Download from '@/views/DownloadView.vue'
import Requirements from '@/views/RequirementsView.vue'
import FlagEnglish from '@/components/FlagEnglish.vue'
import FlagFrench from '@/components/FlagFrench.vue'

export default defineComponent({
  name: 'AzuriomInstaller',
  components: {
    FlagEnglish,
    FlagFrench,
    Download,
    Requirements,
  },
  data() {
    return {
      preLoading: true,
      loading: false,
      errors: [] as string[],
      step: 'requirements',
      data: null as unknown as FetchedData | null,
    }
  },
  computed: {
    phpIniPath(): string {
      if (this.data && this.data.phpIniPath) {
        return this.data.phpIniPath
      }

      return this.$t('unknown')
    },
  },
  mounted() {
    this.refreshRequirements()
  },
  methods: {
    async refreshRequirements() {
      this.errors = []
      this.loading = true

      try {
        const response = await baseFetch()

        if (!response.data.requirements) {
          this.addError(this.$t('error', { error: 'No data in response' }))
          this.step = 'error'
          this.preLoading = false
          return
        }

        this.data = response.data
        this.loading = false
      } catch (e) {
        this.handleAxiosError(e as AxiosError)
      }

      this.preLoading = false
    },

    showDownload(): void {
      this.step = 'download'
    },

    async download() {
      this.errors = []
      this.loading = true

      try {
        await download()

        setTimeout(() => {
          this.loading = false
          this.reloadPage()
        }, 750)
      } catch (e) {
        this.handleAxiosError(e as AxiosError)
      }
    },

    handleAxiosError(error: AxiosError) {
      this.loading = false

      if (this.preLoading) {
        this.step = 'error'
      }

      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        this.addError(error.response.data.message)
        return
      }

      this.addError(this.$t('error', { error }))
    },

    addError(error: string) {
      this.errors.push(error)
    },

    setLocale(locale: string) {
      this.$i18n.locale = locale
    },

    reloadPage() {
      // Force reloads on supported browsers. On other browsers, the boolean
      // will just be ignored.
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      window.location.reload(true)
    },
  },
})
